import { $authHost } from ".."

export const getGoodInBoxAPI = async ({ boxId }) => {
    const {data} = await $authHost.get(`api/boxes/goods_in_box/${boxId}`)
    return data
}

export const getGoodsAllAPI = async ({ goodTypeId }) => {
    const {data} = await $authHost.get(`api/products/all/good_type/${goodTypeId}`)
    return data
}

export const getGoodsByFactoryLineIdAndPackIdAllAPI = async ({ packId, factoryLineId }) => {
    let params = ''

    if (packId && factoryLineId) {
        params = `?packId=${packId}&factoryLineId=${factoryLineId}`
    }

    const {data} = await $authHost.get(`api/products/get_goods_by_factory_line_id_and_pack_id${params}`)
    return data
}